export const siteInfo = {
  organizer: 'H.Y企画',
  operator: '炭乃家',
  area: '熊本県内',
  areaNote: '熊本県内のトライアル各店舗を中心に、複数地域で継続開催中',
  eventName: 'トライアルフェスタ',
  eventNameEn: 'TRIAL FESTA',
  catchCopy: 'いつもの駐車場が、いちばん近い祭になる。',
  dateLabel: '調整中',
  venueLabel: 'トライアル各店舗',
  admissionLabel: '無料',
  venueNote: '※ 会場により仕様は異なります。',
};

export const navItems = [
  { en: 'CONCEPT', jp: 'コンセプト', href: '#concept' },
  { en: 'SCHEDULE', jp: '開催情報', href: '#schedule' },
  { en: 'VENDOR', jp: '出店者募集', href: '#vendor' },
  { en: 'SPONSOR', jp: '企業協賛', href: '#sponsor' },
  { en: 'CONTACT', jp: 'お問い合わせ', href: '#contact' },
];

export const heroImage =
  'https://static.readdy.ai/image/cf8bca050c2d0844a3e8e518767d997b/47dd5b1495db0817be9d0de52c9cdf13.jpeg';

export const heroImageAlt =
  'トライアルフェスタのキービジュアル。提灯が並ぶ夜の会場に、屋台とTRIAL店舗、集まった人々の賑わしが広がる';

export const conceptImage =
  'https://public.readdy.ai/ai/img_res/edited_ea48ad1a91cda5ead56216d60bc6d6ba_61ffa8a0.jpg';

export const quickActions = [
  {
    id: 'sponsor',
    kicker: 'FOR COMPANIES',
    title: '企業協賛募集',
    lead: '地域企業の想いを、イベントの熱気と一緒に届けませんか。',
    href: '#sponsor',
    icon: 'ri-mail-send-line',
    tone: 'primary' as const,
  },
  {
    id: 'vendor',
    kicker: 'FOR VENDORS',
    title: '出店者募集',
    lead: 'キッチンカーも、屋台も、ハンドメイドも。会場に並べてみませんか。',
    href: '#vendor',
    icon: 'ri-store-2-line',
    tone: 'secondary' as const,
  },
];

export const concepts = [
  {
    title: '復興',
    sub: 'RECOVERY',
    text: '止まっていた日常を、もう一度動かす。買い物のついでに立ち寄れる、身近な場所での催しを続けていきます。',
  },
  {
    title: '交流',
    sub: 'COMMUNITY',
    text: '屋台の前で、子どもも大人も同じ目線になれる。初めて会う人同士が自然に混ざり合う時間をつくります。',
  },
  {
    title: '継続',
    sub: 'NEXT',
    text: '一度きりの催しで終わらせず、次の店舗、次の地域へ。続けることで地域に根づいていきます。',
  },
];

export const scheduleItems = [
  {
    id: 'event-01',
    en: 'SHIN YATSUSHIRO EKIMAE',
    area: 'トライアル新八代駅前店',
    date: '調整中',
    venue: 'トライアル新八代駅前店 駐車場',
    admission: '無料',
    status: '出店者募集中',
    statusKey: 'open' as const,
    open: true,
    note: '屋台・キッチンカー・ハンドメイドの出店者を募集しています。開催日は決定次第更新します。',
  },
  {
    id: 'event-02',
    en: 'YATSUSHIRO',
    area: 'トライアル八代店',
    date: '調整中',
    venue: 'トライアル八代店 駐車場',
    admission: '無料',
    status: '出店者募集中',
    statusKey: 'open' as const,
    open: true,
    note: '出店枠に限りがあります。早期に締め切る場合がありますので、お早めにご応募ください。',
  },
  {
    id: 'event-03',
    en: 'ASO',
    area: 'トライアル阿蘇店',
    date: '調整中',
    venue: 'トライアル阿蘇店 駐車場',
    admission: '無料',
    status: '出店者募集中',
    statusKey: 'open' as const,
    open: true,
    note: '出店内容に応じて配置を調整します。ご相談はお気軽にどうぞ。',
  },
  {
    id: 'event-04',
    en: 'OTHER AREAS',
    area: 'トライアル各地',
    date: '調整中',
    venue: 'トライアル各店舗 駐車場',
    admission: '無料',
    status: '順次開催',
    statusKey: 'open' as const,
    open: true,
    note: '上記以外のトライアル各店舗でも順次開催予定です。開催をご希望の店舗があればご相談ください。',
  },
];

export const vendorRequirements = [
  { label: '募集対象', value: 'キッチンカー / 屋台・テント / ハンドメイド・物販' },
  { label: '出店形態', value: 'キッチンカー、テント、机ブースからお選びいただけます' },
  { label: '出店料', value: '調整中（決定次第ご案内します）' },
  { label: '電源について', value: '会場からの電源供給はありません。必要な機材の電源は各自でご持参ください' },
  {
    label: '設備・備品',
    value: 'テント・机・椅子・夜間の電気などのご準備は、全て出店者様でのご用意となります',
  },
  {
    label: '申込方法',
    value: '下記フォーム、または公式LINE・SNSのDMよりご連絡ください（電話番号・LINE ID・屋号は必須です）',
  },
];

export const vendorEventOptions = [
  { value: 'event-01', label: 'トライアル新八代駅前店（開催日 調整中）', open: true },
  { value: 'event-02', label: 'トライアル八代店（開催日 調整中）', open: true },
  { value: 'event-03', label: 'トライアル阿蘇店（開催日 調整中）', open: true },
  { value: 'event-04', label: 'トライアル各地（順次開催）', open: true },
  {
    value: 'any',
    label: '今後の開催すべて（日程は調整中）',
    open: true,
  },
];

export const vendorStyleOptions = ['キッチンカー', 'テント（屋台）', 'ハンドメイド・物販', 'その他'];

export const performerInfo = {
  title: '出演者・パフォーマー募集',
  en: 'PERFORMER',
  lead: '大道芸、ダンス、演奏、ワークショップ。会場に賑わいを生み出してくれる表現者を募集しています。',
  items: [
    { label: '募集ジャンル', value: '大道芸 / ダンス / 演奏 / パフォーマンス / ワークショップ' },
    { label: '出演条件', value: '投げ銭形式（投げ銭での出演となります）' },
    { label: '応募方法', value: 'お問い合わせフォームの「出演・パフォーマンス」よりご連絡ください' },
  ],
  image:
    'https://readdy.ai/api/search-image?query=Street%20performer%20juggling%20with%20a%20small%20audience%20of%20children%20and%20parents%20cheering%20in%20a%20supermarket%20parking%20lot%20festival%20at%20dusk%2C%20warm%20backlight%2C%20string%20lights%20and%20food%20trucks%20in%20the%20background%2C%20deep%20green%20and%20amber%20tones%2C%20cinematic%20film%20photography%20with%20grain%2C%20joyful%20community%20atmosphere&width=1400&height=1000&seq=hyfes-performer-street-01&orientation=landscape&nocache=true',
};

export const sponsorBenefits = [
  { icon: 'ri-flag-2-line', title: '会場内での掲出', text: '会場内の導線やメインエリアへの企業名・ロゴ掲出を予定しています。' },
  { icon: 'ri-smartphone-line', title: 'WEB・SNSでの告知', text: '公式サイトおよびSNSにて、協賛企業としてご紹介します。' },
  { icon: 'ri-store-2-line', title: 'ブース出展のご相談', text: '会場でのPRブース出展についても個別にご相談いただけます。' },
  { icon: 'ri-hand-heart-line', title: '地域への貢献', text: '地域の復興と賑わいを支える取り組みとして、社会的な意義も訴求できます。' },
];

export const sponsorPlans = [
  { name: 'GOLD', label: 'ゴールド協賛', price: '10万円', note: '最も目立つ形での掲出を想定したプランです。' },
  { name: 'SILVER', label: 'シルバー協賛', price: '5万円', note: '会場掲出とWEB告知を中心としたプランです。' },
  { name: 'SUPPORT', label: 'サポート協賛', price: '3万円', note: '物品・サービスでのご協賛もご相談ください。' },
  { name: 'PARTNER', label: 'パートナー協賛', price: '1万円', note: 'まずは小さく関わりたい企業さま向けのプランです。' },
];

export const sponsorImage =
  'https://readdy.ai/api/search-image?query=Japanese%20company%20booth%20with%20a%20small%20banner%20and%20balloons%20at%20an%20outdoor%20local%20festival%2C%20a%20business%20owner%20handing%20a%20flyer%20to%20a%20visitor%2C%20friendly%20natural%20expressions%2C%20food%20trucks%20and%20warm%20lights%20blurred%20in%20the%20background%2C%20documentary%20editorial%20photography%2C%20amber%20tones%2C%20trust%20and%20partnership%20atmosphere&width=1400&height=1000&seq=hyfes-sponsor-booth-01&orientation=landscape&nocache=true';

export interface Organization {
  role: string;
  name: string;
  en: string;
  text: string;
  image?: string;
  imageAlt?: string;
  imageType?: 'logo' | 'photo';
}

export const organizations: Organization[] = [
  {
    role: '主催',
    name: 'H.Y企画',
    en: 'H.Y KIKAKU',
    text: '熊本を拠点に、地域イベントの企画・運営を行うチームです。開催店舗や地域の事業者と連携しながら、その土地らしい催しをかたちにしていきます。',
    image:
      'https://static.readdy.ai/image/cf8bca050c2d0844a3e8e518767d997b/5bdf20c8f57952e8570c6092107faa1b.jpeg',
    imageAlt: 'H.Y企画のロゴ。山並みとステージ、キッチンカーのシルエットが描かれたエンブレム',
    imageType: 'logo',
  },
  {
    role: '運営',
    name: '炭乃家',
    en: 'SUMINOYA',
    text: '熊本県内で炭火焼き鳥を販売しています。その傍ら、トライアル各店舗にて復興イベント「トライアルフェスタ」を開催し、出店者の募集から当日の運営まで一貫して対応しています。',
    image:
      'https://static.readdy.ai/image/cf8bca050c2d0844a3e8e518767d997b/75263e935c18c9e66ec8f75659eaf977.jpeg',
    imageAlt: '炭乃家の炭火焼き鳥。炭の上で焼き上げる串と、のれん越しの店内',
    imageType: 'photo',
  },
];

export const companyProfile = [
  { label: 'イベント名', value: '復興イベント トライアルフェスタ' },
  { label: '主催', value: 'H.Y企画' },
  { label: '運営', value: '炭乃家' },
  { label: '開催店舗', value: 'トライアル新八代駅前店 / 八代店 / 阿蘇店 / 各地 ほか' },
  { label: '開催日', value: '調整中（決定次第お知らせします）' },
  { label: '入場料', value: '無料' },
  { label: '連絡方法', value: '公式LINE・SNSのDMを基本とし、電話・メールでも対応' },
];

export interface SnsLink {
  name: string;
  handle: string;
  href: string;
  icon: string;
  available: boolean;
  qr?: string;
}

export const snsLinks: SnsLink[] = [
  {
    name: 'X',
    handle: '@sumino_ya1',
    href: 'https://x.com/sumino_ya1?s=11',
    icon: 'ri-twitter-x-line',
    available: true,
  },
  {
    name: 'Threads',
    handle: '@sumino_ya',
    href: 'https://www.threads.com/@sumino_ya?igshid=NTc4MTIwNjQ2YQ==',
    icon: 'ri-threads-line',
    available: true,
  },
  {
    name: 'Instagram',
    handle: '@sumino_ya',
    href: 'https://www.instagram.com/sumino_ya/',
    icon: 'ri-instagram-line',
    available: true,
    qr: 'https://static.readdy.ai/image/cf8bca050c2d0844a3e8e518767d997b/7ad7ad7f551a86c79d79438979335215.jpeg',
  },
  {
    name: 'LINE',
    handle: 'QRコードから追加',
    href: '',
    icon: 'ri-line-line',
    available: false,
    qr: 'https://static.readdy.ai/image/cf8bca050c2d0844a3e8e518767d997b/1965f0481c0289c5a3db1d7efe140519.jpeg',
  },
];

export const contactCategories = [
  '出店に関するお問い合わせ',
  '企業協賛に関するお問い合わせ',
  'イベント出演・パフォーマンスに関するお問い合わせ',
  'その他のお問い合わせ',
];

export const contactImage =
  'https://readdy.ai/api/search-image?query=Wide%20night%20view%20of%20a%20Japanese%20local%20festival%20in%20a%20supermarket%20parking%20lot%2C%20silhouettes%20of%20visitors%20walking%20between%20kitchen%20cars%20and%20white%20tents%2C%20rows%20of%20warm%20lanterns%20and%20light%20strings%20stretching%20into%20the%20distance%2C%20deep%20green%20trees%20and%20dark%20sky%2C%20cinematic%20film%20photography%20with%20subtle%20grain%2C%20calm%20festive%20atmosphere&width=1600&height=900&seq=hyfes-contact-night-01&orientation=landscape&nocache=true';